import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=55c3c7dd"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports